import { Box, Button, EthSign, Flex } from 'components/ui';
import Tooltip from 'components/ui/Tooltip';
import * as React from 'react';
import { LOGO_GRADIENT } from 'utils/colors';

interface StakingStatsProps {
  genesisApproved: boolean;
  enigmaApproved: boolean;
  enigmaChecked: boolean;
  genesisChecked: boolean;
  approveEnigma(): any;
  approveGenesis(): any;
  totalStaked: number;
  maxPairs: number;
  pendingRewards: string;
  claim(): any;
  approvingEnigma: boolean;
  approvingGenesis: boolean;
  capReached: boolean;
}

const StatsButton = (props: any) => (
  <Button boxShadow="1" fontWeight="600" borderRadius="10px" p="2" fontSize="1" {...props} />
);

const StakingStats: React.FC<StakingStatsProps> = ({
  genesisApproved,
  enigmaApproved,
  approveEnigma,
  approveGenesis,
  totalStaked,
  enigmaChecked,
  genesisChecked,
  pendingRewards,
  claim,
  approvingEnigma,
  approvingGenesis,
  maxPairs,
  capReached,
}) => {
  return (
    <Flex alignCenter width="100%" my="3" wrap="true" justifyContent={['center', 'space-between']}>
      <Box mr="3" mb="2">
        <Box>
          Total Pairs Staked: {totalStaked} of {maxPairs}
        </Box>
        {capReached && (
          <Box fontSize="1" color="aqua">
            Staking disabled - max staked count reached
          </Box>
        )}
      </Box>
      <Flex mb="2">
        {genesisChecked && !genesisApproved && (
          <StatsButton
            onClick={approveGenesis}
            background={LOGO_GRADIENT}
            p="3"
            disabled={Boolean(approvingGenesis)}
            mr="3"
            data-tip="genesistip"
            data-for="genesisApprovalTip"
          >
            Activate Genesis Staking
          </StatsButton>
        )}
        {enigmaChecked && !enigmaApproved && (
          <StatsButton
            onClick={approveEnigma}
            background={LOGO_GRADIENT}
            p="3"
            disabled={Boolean(approvingEnigma)}
            data-tip="enigmatip"
            data-for="enigmaApprovalTip"
          >
            Activate Enigma Staking
          </StatsButton>
        )}
      </Flex>
      <Flex
        justifyEnd
        flex="0 1 auto"
        alignCenter
        borderColor="highlight"
        border="2px solid"
        p="2"
        borderRadius="3"
        mb="2"
      >
        <Box mr="2" fontSize="1">
          Available Reward
        </Box>
        <EthSign value={pendingRewards} />
        <StatsButton ml="2" bg="highlight" onClick={claim} disabled={pendingRewards === '0.0'}>
          Claim
        </StatsButton>
      </Flex>

      {enigmaChecked && !enigmaApproved && (
        <Tooltip id="enigmaApprovalTip" place="bottom" effect="solid">
          Before staking for the first time, users must submit an approval transaction to allow the
          staking contract to move your Enigma prints on your behalf. This only needs to be
          submitted once.
        </Tooltip>
      )}
      {genesisChecked && !genesisApproved && (
        <Tooltip id="genesisApprovalTip" place="bottom" effect="solid">
          Before staking for the first time, users must submit an approval transaction to allow the
          staking contract to move your Genesis prints on your behalf. This only needs to be
          submitted once.
        </Tooltip>
      )}
    </Flex>
  );
};

export default StakingStats;
